
import React, { Component } from 'react'
import t from 'tcomb-form'
import Form from 'ui/Form'
import Space from 'ui/Space'
import Button from 'ui/Button'

const FormSchema = t.struct({
  email: t.String
})

const FormOptions = {
  fields: {
    email: {
      type: 'email',
      label: 'Email Address',
      attrs: { required: true, autoFocus: true }
    }
  }
}

class ForgotForm extends Component {
  render () {
    const values = {
      email: this.props.email
    }

    return (
      <div className='ForgotForm'>
        <Form schema={FormSchema} options={FormOptions} values={values} onSubmit={this.props.onSubmit} onChange={this.props.onChange}>
          <Space value='20' />
          <Button type='submit' loading={this.props.isLoading} disabled={this.props.isLoading} extras='fluid'>
            {this.props.isLoading ? 'Sending email...' : 'Send Reset Email'}
          </Button>
        </Form>
      </div>
    )
  }
}

export default ForgotForm



// WEBPACK FOOTER //
// ./components/ForgotForm.js